import * as MyString from "./string.js";

/**
 *
 **/
export function GetDayAndTime_YYYYMMDDHHMMSS() {
  let now = new Date();

  let year = MyString.InsertZeroes(now.getFullYear().toString(), 4);
  let month = MyString.InsertZeroes((now.getMonth() + 1).toString(), 2);
  let day = MyString.InsertZeroes(now.getDate().toString(), 2);
  let hours = MyString.InsertZeroes(now.getHours().toString(), 2);
  let minutes = MyString.InsertZeroes(now.getMinutes().toString(), 2);
  let seconds = MyString.InsertZeroes(now.getSeconds().toString(), 2);

  return year + month + day + hours + minutes + seconds;
}
